export const trandingUEN = '202536873W';
export const trandingCompanyName = 'TR@NDING PTE. LTD.';
export const trandingPhone = '89766997';
